const windowBlur = () => {
  try {
    document?.activeElement?.blur();
  } catch {
  }
};

export { windowBlur };
//# sourceMappingURL=windowBlur.js.map
